import { gql } from '@apollo/client';
import { DocumentNode } from 'graphql';
import * as React from 'react';

import { getProfessionalDetail } from '@/utilities';

import { SpeakerUser_userFragment } from './graphql-types/SpeakerUser_userFragment';

export const SpeakerUser: React.FC<{
  user: SpeakerUser_userFragment;
  isHtml: boolean;
}> & {
  userFragment: DocumentNode;
} = (props) => {
  if (!props.user) {
    return null;
  }

  const professionalDetail = getProfessionalDetail(
    props.user.jobTitle,
    props.user.company
  );

  if (props.isHtml) {
    return (
      <li>
        {props.user.displayName}
        {professionalDetail}
      </li>
    );
  }
  return (
    <>
      {` - ${props.user.displayName} `}
      {!!professionalDetail && `(${professionalDetail})`} <br />
    </>
  );
};

SpeakerUser.userFragment = gql`
  fragment SpeakerUser_userFragment on User {
    _id
    displayName
    jobTitle
    company
  }
`;
